import React from 'react';
import { fmtDateTime } from '../../utils/helpers';

// Mobile (APK) OTP — full-width, big numeric input.
export default function OTPMobile({ vm }) {
  const { mobile, boundModel, boundDate, otp, setOtp, busy, err, sent, reused, resend, verify, backToLogin } = vm;
  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">Verify OTP</div>
      <div className="muted auth-mobile-sub">
        This account is signed in on another device
        {boundModel ? <> (<strong>{boundModel}</strong>{boundDate ? `, since ${fmtDateTime(boundDate)}` : ''})</> : null}.
        Verify the OTP to move it to <strong>this phone</strong> — the other device will be signed out.
      </div>
      <div className="muted auth-mobile-sub">
        {!sent ? 'Sending OTP…' : reused
          ? `Use the OTP already sent to WhatsApp ${mobile} at ${fmtDateTime(reused)} — valid for 1 hour, no new code was sent.`
          : `OTP sent to WhatsApp ${mobile} (valid for 1 hour)`}
      </div>
      <form onSubmit={verify} className="auth-mobile-form">
        <label className="field">4-digit OTP
          <input type="tel" inputMode="numeric" maxLength={4} value={otp} className="auth-mobile-otp" autoFocus
            onChange={(e) => setOtp(e.target.value)} />
        </label>
        {err && <div className="auth-mobile-err">{err}</div>}
        <button className="btn primary auth-mobile-btn" disabled={busy}>
          {busy ? 'Verifying…' : 'Verify & Continue'}
        </button>
      </form>
      <div className="auth-mobile-links">
        {sent && <button type="button" className="linklike" onClick={resend}>Resend OTP</button>}
        <button type="button" className="linklike" onClick={backToLogin}>Back to login</button>
      </div>
      <div className="muted" style={{ fontSize: 12, marginTop: 16, textAlign: 'center' }}>
        No WhatsApp on this number? Ask a Super Admin to reset your device, then sign in again.
      </div>
    </div>
  );
}
